export const MAX_CUSTOM_TEMPLATE_WEEKS = 12;
export const MAX_CUSTOM_TEMPLATE_DAYS = MAX_CUSTOM_TEMPLATE_WEEKS * 7;



// WEBPACK FOOTER //
// ./src/constants/customTemplate.ts